import { apiFetch } from "./client";
import type { PacienteIn, PacienteOut } from "@/types/api";

export async function list(params?: { search?: string }): Promise<PacienteOut[]> {
  const qs = params?.search
    ? `?q=${encodeURIComponent(params.search)}`
    : "";
  const res = await apiFetch<{ items: PacienteOut[]; count: number }>(`/pacientes/${qs}`);
  return res?.items || (Array.isArray(res) ? res : []);
}

export function get(dni: string): Promise<PacienteOut> {
  return apiFetch<PacienteOut>(`/pacientes/${dni}`);
}

export function create(data: PacienteIn): Promise<PacienteOut> {
  return apiFetch<PacienteOut>("/pacientes/", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function update(dni: string, data: PacienteIn): Promise<PacienteOut> {
  return apiFetch<PacienteOut>(`/pacientes/${dni}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export function remove(dni: string): Promise<void> {
  return apiFetch<void>(`/pacientes/${dni}`, { method: "DELETE" });
}

export function updatePipeline(dni: string, pipeline: string): Promise<PacienteOut> {
  return apiFetch<PacienteOut>(`/pacientes/${dni}/pipeline/`, {
    method: 'PATCH',
    body: JSON.stringify({ pipeline }),
  });
}
